import * as CreatePasswordStage from 'constants/CreatePasswordStage';
import * as CreatePasswordActions from '../../actions/createPassword';
import * as FastJoin from '../../actions/auth/FastJoin';

export default function createPassword(state = new Map, action = {}) {
    switch (action.type) {
        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE:
            if(!action.data.hasOwnProperty('Error')) {
                return {...state, stage: CreatePasswordStage.INIT};
            }
            return state;
        case CreatePasswordActions.SUCCESS_CREATE_PASSWORD:
            if (action.data.ResultState === 0) {
                return {...state, stage: CreatePasswordStage.SUCCESS};
            } else {
                return {...state, stage: CreatePasswordStage.INTERNAL_ERROR};
            }
        case CreatePasswordActions.FAILURE_CREATE_PASSWORD:
            return {...state, stage: CreatePasswordStage.INTERNAL_ERROR};

        case CreatePasswordActions.INIT_CREATE_PASSWORD:
            return {...state, stage: CreatePasswordStage.NONE};

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./js/shared/reducers/createPasswordReducer.js